<template>
    <a-modal v-model="visible" title="国补名额核销" :width="400" centered :confirmLoading="loading" @ok="doValidate()">
        <a-form-model ref="formRef" :model="formData">
            <a-form-model-item label="编号" prop="code" :rules="{ required: true, message: '请输入编号' }">
                <a-input v-model="formData.code" placeholder="请输入编号" />
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script>
import utils from '@/common/utils';

export default {
    data() {
        return {
            visible: false,
            loading: false,
            formData: {
                code: ''
            }
        }
    },
    methods: {
        show() {
            this.formData.code = '';
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.formRef.clearValidate();
                this.$refs.formRef.resetFields();
            })
        },
        doValidate() {
            this.$refs.formRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.loading = true;
                this.http.post('/platform/guobu/verify', this.formData).then(res => {
                    utils.showMsg('核销成功').then(() => {
                        this.$emit('success')
                    });
                }).finally(() => {
                    this.loading = false;
                })
            })
        }
    }
}
</script>

<style></style>